var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ModalBase,{attrs:{"closeable":"","heading":"Log In","show":_setup.show},on:{"close":_setup.close}},[_c(_setup.LoginForm,{attrs:{"current-page-url":_setup.isErrorPage ? undefined : _vm.$route.fullPath},on:{"close":_setup.close,"logged-in":_setup.loggedIn}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }